import { render, staticRenderFns } from "./customerLogsTable.vue?vue&type=template&id=0c7abc94&"
import script from "./customerLogsTable.vue?vue&type=script&lang=ts&"
export * from "./customerLogsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports